import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { Header as SemanticHeader, Icon } from "semantic-ui-react";
import "./CardButton.scss";

const CardButtonComponent = ({
  title,
  subtitle,
  icon,
  url = "",
  ...props
}) => {
  const handleClick = () => (url ? props.history.push(url) : null);

  return (
    <SemanticHeader
      className="hireart-ds-card-button"
      onClick={handleClick}
      {...props}
    >
      {icon && <Icon name={icon} />}
      <SemanticHeader.Content>
        {title}
        <SemanticHeader.Subheader>{subtitle}</SemanticHeader.Subheader>
      </SemanticHeader.Content>
    </SemanticHeader>
  );
};

CardButtonComponent.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  icon: PropTypes.string,
  url: PropTypes.string,
};

export const CardButton = withRouter(CardButtonComponent);

